import {
    ICubeSourceHierarchyPolicy,
    ICubeSourcePolicyHierarchyProperties,
    IDimensionPolicyOptions
} from "../../PA.HyperRectangle.Core/CubeSource.IF";
import { DimensionType, IHierarchyFilterOptions } from '../../PA.Core/PA.Core.IF.Hierarchy'
import * as _ from "lodash";
import { WB_CustomerRow, WB_PeriodRow, WB_PlanRow, WB_PlanTypeRow } from "../../PA.Core/PAdbSchemaRows";
import { PAdbContext } from "../../PA.Core/PAdbContext";
import { esWB_Customer, esWB_Period, esWB_Period_Type, esWB_Plan, esWB_Plan_Type } from "../../PA.Core/PAdbSchema";
import { CreateOptions } from '../../PA.Core/lib/ESRecordResolver'


export class PlanTypeHierarchyPolicy
    implements
        ICubeSourceHierarchyPolicy
{
    private dbContext: PAdbContext
    constructor() {
        this.dbContext = new PAdbContext()
    }
    get PolicyId(): string { return "PlanM" }

    async getHierarchyProperties(dimType: DimensionType, options: IDimensionPolicyOptions): Promise<ICubeSourcePolicyHierarchyProperties> {

        let WB_PeriodRow: WB_PeriodRow = undefined
        let WB_CustomerRow: WB_CustomerRow = undefined

        if(_.isEmpty(options) || _.isEmpty(options?.CubeSource))
            return undefined

        //-- Get the Plan Type Row
        let planTypeRow: WB_PlanTypeRow = undefined
        if(!_.isEmpty(options.WB_PlanTypeRow))
            planTypeRow = options.WB_PlanTypeRow
        else if (_.isNumber(options.WB_PLANM_ID))
            planTypeRow = await this.dbContext.find(esWB_Plan_Type, options.WB_PLANM_ID)

        let planIds = options.CubeSource.getParameter('Plan')
        if(!_.isEmpty(planIds)){
            let plans: WB_PlanRow[] = <any> await this.dbContext.findUsingCache(esWB_Plan,<any> planIds)
            let plan = _.first(plans)

            if(!_.isEmpty(plan)){
                await plan.loadRelations([esWB_Customer, esWB_Period, esWB_Plan_Type])
                WB_PeriodRow = plan.WB_PeriodRow
                WB_CustomerRow = plan.WB_CustomerRow_Planning
                if(_.isEmpty(planTypeRow))
                    planTypeRow = plan.WB_PlanTypeRow
            }
        }

        if(_.isEmpty(planTypeRow))
            return undefined

        if(_.isEmpty(planTypeRow.WB_PeriodTypeRow))
            await planTypeRow.loadRelations([esWB_Period_Type])

        switch(dimType){

            case DimensionType.Customer:
                return {
                    HierarchyId: planTypeRow.cif.WB_CUSTH_ID,
                    LeafLevel: WB_CustomerRow?.cif?.CUSTOMER_TYPE,
                    EffectiveStartDt: WB_PeriodRow?.PeriodStartDt,
                    EffectiveEndDt: WB_PeriodRow?.PeriodEndDt
                }


            case DimensionType.Product:
                return {
                    HierarchyId: planTypeRow.cif.WB_PRDH_ID,
                    LeafLevel: planTypeRow.cif.PRDGRP_LEVEL_ID,
                    EffectiveStartDt: WB_PeriodRow?.PeriodStartDt,
                    EffectiveEndDt: WB_PeriodRow?.PeriodEndDt
                }

            case DimensionType.Time: {
                let filterOpts: IHierarchyFilterOptions = {}
                let periodLeafLevel = planTypeRow.WB_PeriodTypeRow?.cif?.PERIOD_TYPE_ID  // This may become a problem

                let visLevels = planTypeRow.cif.PERIODH_VISIBLE_LEVELS.trim().split(",")
                visLevels = _.filter(visLevels, l => !_.isEmpty(l))
                if(!_.isEmpty(visLevels)){
                    if(!_.includes(visLevels, periodLeafLevel)){
                        visLevels.push(periodLeafLevel)
                    }
                    filterOpts.PruneToLevels = visLevels
                }
                return {
                    HierarchyId: planTypeRow.cif.WB_PERIODH_ID,
                    LeafLevel: periodLeafLevel,
                    EffectiveStartDt: WB_PeriodRow?.PeriodStartDt,
                    EffectiveEndDt: WB_PeriodRow?.PeriodEndDt,
                    HierarchyCreateOptions: {},
                    HierarchyFilterOptions: filterOpts
                }
            }


            case DimensionType.TimeSecondary: {
                let filterOpts: IHierarchyFilterOptions = {}
                let periodLeafLevel = planTypeRow.WB_PeriodTypeRow?.cif?.PERIOD_TYPE_ID  // This may become a problem

                let visLevels = planTypeRow.cif.PERIODH_MONTH_VISIBLE_LEVELS.trim().split(",")
                visLevels = _.filter(visLevels, l => !_.isEmpty(l))
                if(!_.isEmpty(visLevels)){
                    if(!_.includes(visLevels, periodLeafLevel)){
                        visLevels.push(periodLeafLevel)
                    }
                    filterOpts.PruneToLevels = visLevels
                }
                return {
                    HierarchyId: planTypeRow.cif.WB_PERIODH_ID_MONTH,
                    LeafLevel: periodLeafLevel,
                    EffectiveStartDt: WB_PeriodRow?.PeriodStartDt,
                    EffectiveEndDt: WB_PeriodRow?.PeriodEndDt,
                    HierarchyCreateOptions: {},
                    HierarchyFilterOptions: filterOpts,
                    bSkip: !planTypeRow.bMonthHierarchyShowInHRInd
                };
            }
            default:
                return undefined

        }
    }

}